module.exports = __webpack_public_path__ + "img/dart.a675cb93.png";